<template>
  <div>
    <div class="videoHighLightsContainer">
      <div class="headerText">Highlights</div>
      <div
        class="singleHighlight"
        v-for="(highlight, index) in data"
        :key="index"
        @click="highlightClicked(highlight.startTime)"
      >
        <div class="imgContainer">
          <div
            class="loadingContainer"
            :style="
              highlight.imgSource == null ? 'display:flex' : 'display:none'
            "
          >
            <div class="loader"></div>
          </div>
          <img
            :src="highlight.imgSource"
            :style="
              highlight.imgSource == null ? 'display:none' : 'display:flex'
            "
          />
        </div>
        <div class="textContainer">
          <div class="titleText">
            {{ highlight.title }}
          </div>
          <div class="descriptionText">
            {{ highlight.description }}
          </div>
          <div class="timeText">
            {{ highlight.startTime }}  <span v-if="!highlight.isActive">({{ highlight.timeDifference }})</span><span v-if="highlight.isActive">({{ highlight.remainingTime }})</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../scss/highlights.css";
import Vue from 'vue'
import timeMixin from '../mixins/timeMixin'

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  created() {
    this.data.forEach((element) => {
      element.parsedStart = this.convertHoursMinsSecsToSeconds(element.startTime);
      element.parsedEnd = this.convertHoursMinsSecsToSeconds(element.endTime);
      Vue.set(element, "remainingTime", "");
      Vue.set(element, "timeDifference", this.convertSecondsToHourMinsSecs(element.parsedEnd-element.parsedStart));
      Vue.set(element, "isActive", false);
    });
  },
  methods: {
    runFirstLoad() {
      this.onVisible();
    },
    highlightClicked(startTime) {
      this.$root.$emit('seekVideo',this.convertHoursMinsSecsToSeconds(startTime)) 
      this.$root.$emit('playVideo') 
    },
    async getVideoImageAsynced(index) {
      var clonedVideo = document.querySelector("video").cloneNode(true);
      clonedVideo.addEventListener("seeked", async () => {
        this.data[index].imgSource = await this.capture(clonedVideo);
      });
      clonedVideo.currentTime = this.convertHoursMinsSecsToSeconds(
        this.data[index].captureImageAtTime
      );
    },
    capture(video) {
      return new Promise((resolve, reject) => {
        var canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        canvas.toBlob((blob) => {
          if (blob == null) reject();
          else resolve(window.URL.createObjectURL(blob));
        });
      });
    },
    onVisible() {
      this.data.forEach(async (item, index) => {
        if (item.captureImageAtTime != null)
          await this.getVideoImageAsynced(index);
      });
    },
    process(time) {
      this.data.forEach(element => {
        if(time>element.parsedStart&&time<element.parsedEnd){
          element.isActive=true;
          element.remainingTime=this.convertSecondsToHourMinsSecs(element.parsedEnd-time)
        }
        else{
          element.isActive=false;
        }
      });
    },
  },
  mixins:[timeMixin]
};
</script>
